// @file Helper functions for surface comments
import { CommentDraftState } from '@@/enums'
import type { Comment, CommentDraft, ReadonlyComment } from '@@/types/surface_comments'
import { uniqueId } from 'es-toolkit/compat'

const addCommentCidIfAbsent = (comment) => {
  if (comment.cid) return comment
  if (comment.id != null) return { ...comment, cid: `comment_${comment.id}` }
  return { ...comment, cid: uniqueId('comment_new_') }
}

// Creates a new comment draft with default attributes.
const newCommentDraft = (attributes: Partial<CommentDraft>): CommentDraft => {
  return addCommentCidIfAbsent({
    draftState: CommentDraftState.Writing,
    draftStartedAt: new Date().toISOString(),
    ...attributes,
  })
}

const isDraftEmpty = (draft: CommentDraft): boolean => {
  const trimmedHtmlBody = draft.html_body?.trim() ?? ''
  if (trimmedHtmlBody !== '') return false

  const attachment = draft.attachment ?? null
  if (attachment != null) return false

  if (hasDraftUpload(draft)) return false

  return true
}

const hasDraftUpload = (draft: CommentDraft): boolean => {
  const uploadingFile = draft?.uploadingFile ?? null
  if (uploadingFile != null) return true

  const uploadJob = draft?.uploadJob ?? null
  if (uploadJob != null) return true

  return false
}
const isDraftForNewComment = (draft: CommentDraft): boolean => {
  return draft.id == null
}

const isDraftForEditedCommentChanged = (comment: Comment | ReadonlyComment, draft: CommentDraft): boolean => {
  const trimmedCommentHtmlBody = comment?.html_body?.trim() ?? ''
  const trimmedDraftHtmlBody = draft?.html_body?.trim() ?? ''
  if (trimmedCommentHtmlBody !== trimmedDraftHtmlBody) return true

  const commentAttachment = comment?.attachment ?? null
  const draftAttachment = draft?.attachment ?? null
  if (commentAttachment !== draftAttachment) return true

  if (hasDraftUpload(draft)) return true

  return false
}

export { addCommentCidIfAbsent, isDraftEmpty, isDraftForEditedCommentChanged, isDraftForNewComment, newCommentDraft }
